<template>
  <VxCurrencyInput
    v-model="value"
    class="input-text-border-none"
    @blur="changeInput"
    @click="onClick"
    @input="onInput"
    @focus="onFocus"
  />
</template>

<script>
import VxCurrencyInput from '@/components/ui/VxCurrencyInput'

export default {
  components: {
    VxCurrencyInput
  },
  data() {
    return {
      value: null,
      colName: null
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.fnBlurCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    },
    onClick(e) {
      e.stopPropagation()
    },
    onInput() {
      this.params.context.componentParent.fnChangeCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    },
    onFocus() {
      this.params.context.componentParent.fnFocusCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    }
  }
}
</script>

<style></style>
